var debugModeCookie = new RegExp(/kbbdebugmode/gi);
export default function () {
  var isDebugModeOn = false;
  if (typeof window !== 'undefined') {
    var hasDebugModeParam = /debugmode/gi.test(window.location.search);
    var turnDebugModeOff = /debugmode=off/gi.test(window.location.search);
    var hasDebugModeCookie = debugModeCookie.test(window.document.cookie);
    isDebugModeOn = (hasDebugModeParam || hasDebugModeCookie) && !turnDebugModeOff;
    var cookieMaxAge = turnDebugModeOff ? -1 : '3600';
    if (hasDebugModeParam) {
      document.cookie = "".concat(debugModeCookie.source, "=on;max-age=").concat(cookieMaxAge, ";");
    }
  }
  return isDebugModeOn;
}